import { render, staticRenderFns } from "./entity-card-bank-statements-detail-general-information.vue?vue&type=template&id=790cf803&"
import script from "./entity-card-bank-statements-detail-general-information.vue?vue&type=script&lang=js&"
export * from "./entity-card-bank-statements-detail-general-information.vue?vue&type=script&lang=js&"
import style0 from "./entity-card-bank-statements-detail-general-information.vue?vue&type=style&index=0&id=790cf803&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports